/**
 * This file imports configuration objects from either the config.dev.js file
 * or the config.prod.js file depending on whether we are in __DEV__ or not.
 *
 * Note that we do not gitignore these files. Unlike on web servers, just because
 * these are not checked into your repo doesn't mean that they are secure.
 * In fact, you're shipping a JavaScript bundle with every
 * config variable in plain text. Anyone who downloads your app can easily
 * extract them.
 *
 * If you doubt this, just bundle your app, and then go look at the bundle and
 * search it for one of your config variable values. You'll find it there.
 *
 * Read more here: https://reactnative.dev/docs/security#storing-sensitive-info
 */
// import BaseConfig from "./config.base"
// import ProdConfig from "./config.prod"
// import DevConfig from "./config.dev"

// let ExtraConfig = ProdConfig

// if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
//   ExtraConfig = DevConfig
// }

// const Config = { ...BaseConfig, ...ExtraConfig }

// export default Config

import BaseConfig from "./config.base";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL!;

const Config = {
  ...BaseConfig,
  // API Endpoints
  API_URL: API_BASE_URL,
  AUTH_URL: `${API_BASE_URL}auth`,
  USER_URL: `${API_BASE_URL}users`,
  PARENT_URL: `${API_BASE_URL}users/parent`,
  CHAT_URL: `${API_BASE_URL}users/chat`,
  DOCUMENTS_URL: `${API_BASE_URL}users/documents`,
  ADMIN_URL: `${API_BASE_URL}admin`,
  PAYMENTS_URL: `${API_BASE_URL}payment`,

  // Third-party services
  STRIPE_URL: process.env.REACT_APP_STRIPE_PUBLIC_KEY!,
  PUBSUB_URL: process.env.REACT_APP_PUBSUB_URL!,
  // API_URL: process.env.API_URL!,
  // AUTH_URL: process.env.AUTH_URL!,
  // USER_URL: process.env.USER_URL!,
  // PARENT_URL: process.env.PARENT_URL!,
  // CHAT_URL: process.env.CHAT_URL!,
  // DOCUMENTS_URL: process.env.DOCUMENTS_URL!,
  // ADMIN_URL: process.env.ADMIN_URL!,
  // PAYMENTS_URL: process.env.PAYMENTS_URL!,
  // STRIPE_URL: process.env.STRIPE_URL!,
  // PUBSUB_URL: process.env.PUBSUB_URL!,
};

export default Config;
